import React from 'react';
import {Route, Redirect} from 'react-router-dom';

// The auth signal ProtectedRoute keys on. True when the visitor has a
// Firebase session (and is not anonymous), is mid sign-in
// (signInSuccessUrl), or carries an `f` token param (native webviews).
// Exported so routes that swap in public content for logged-out visitors
// (e.g. the /bidmii-pro landing page) use the exact same check instead of
// duplicating it.
export const hasActiveAuthSignal = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  return !(
    (sessionStorage.getItem('Firebase-Authorization') === null ||
      localStorage.getItem('isAnonymous')) &&
    !sessionStorage.getItem('signInSuccessUrl') &&
    !urlSearchParams.get('f')
  );
};

export default function ProtectedRoute({
  // @ts-ignore
  component: Component,
  // @ts-ignore
  render: renderFunction,
  ...rest
}) {
  const urlSearchParams = new URLSearchParams(window.location.search);
  let isAuthenticated = true;
  let redirect: $TSFixMe = null;
  if (!hasActiveAuthSignal()) {
    isAuthenticated = false;
    if (urlSearchParams.get('redirect') !== null) {
      redirect = `${window.location.pathname}${window.location.search}`;
    } else {
      if (urlSearchParams.get('migrate') !== null) {
        localStorage.setItem('bidmiiProUid', window.location.pathname);
        redirect = '/login';
      } else {
        redirect = `${window.location.pathname}${window.location.search}`;
        const encodedURI = encodeURIComponent(redirect);
        redirect = `/login?redirect=${encodedURI}`;
      }
    }
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthenticated === true) {
          if (renderFunction) {
            return renderFunction({...props});
          } else if (Component) {
            return <Component {...props} />;
          }
          throw new Error(
            'Must supply either component or render function to ProtectedRoute',
          );
        } else {
          return <Redirect to={redirect} />;
        }
      }}
    />
  );
}
